import * as jwt from "jsonwebtoken";
import * as moment from "moment";

class AuthService {
  auth_token = "auth_token2";
  getToken = () => {
    const  retrievedObject=localStorage.getItem(this.auth_token);
    return JSON.parse(retrievedObject)
  };

  getToken = () => {
    const  retrievedObject=localStorage.getItem(this.auth_token);
    return JSON.parse(retrievedObject)
  };

  decode = token => {
    return jwt.decode(token);
  };
  saveToken = (token) => {
    localStorage.setItem(this.auth_token,JSON.stringify(token));
  };
  removeToken = () => {
    
    localStorage.removeItem(this.auth_token);
  };
  getUsername=()=>{
    return this.this.getToken().FirstName;
  }
  getExpiration = token => {
    const exp = this.decode(token).exp;

    return moment.unix(exp);
  };
  isValid = token => {
    return moment().isBefore(this.getExpiration(token));
  };

  isAuthenticated = () => {
   
    const token = this.getToken();
    return token ;
    // return token && this.isValid(token);
  };
}

export default new AuthService();
